export default class SetupTeacherActivitiesCtrl {

	constructor ($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $timeout) {
		// CONSTANTS
		const setupVM = this

		setupVM.workplan = {}
		setupVM.submodules = []
		// VARIABLES
		setupVM.teachertype = []
		setupVM.teacherCategories = []
		setupVM.isButtonDisabled = false
		// METHODS
		setupVM.checkDoWorkplan = checkDoWorkplan
		setupVM.toggleSubcategories = toggleSubcategories
		setupVM.saveTeacherActivities = saveTeacherActivities
		setupVM.categorySubmodule = {}

		function activate () {
			let header = { workplanId: $stateParams.workPlanId }

			return getAllTeachersActivities(header)
		}

		// SERVICES METHODS

		function getWorkPlanHeader (header) {
			return WorkPlanParametrizationSrv.getWorkPlanHeader.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					setupVM.workplan = dataReturn.data
					setupVM.workplan.id_code = $stateParams.workPlanId
				}
			})
		}

		function saveTeacherActivities () {
			setupVM.information = processActivitiesInformation()
			setupVM.isButtonDisabled = true
			let header = {
				id_work_plan: setupVM.workplan.id_code,
				teachertype : setupVM.information,
			}

			WorkPlanParametrizationSrv.addTeacherSubmodules.add(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					showModalActivitesSetedUp()
					setupVM.isButtonDisabled = false
				} else {
					showModalActivitesSetedUpError(dataReturn.message)
					setupVM.isButtonDisabled = true
				}
			})
		}

		// METHODS
		function processActivitiesInformation () {
			var result = []

			setupVM.teachertype.forEach(function (teacherType) {
				var professorType = {}

				if (teacherType) {
					professorType['submodule'] = []
					for (var association in teacherType) {
						if (association && teacherType[association]) {
							professorType['id_code'] = teacherType[association]
							professorType['submodule'].push({ id_code: association, is_checked: 1 })
						}
					}
				}

				if (professorType['submodule'] && professorType['submodule'].length > 0) { result.push(professorType) }
			})

			return result
		}

		function checkDoWorkplan (subModuleId, teachertype) {
			if (setupVM.teachertype[teachertype]) {
				let isChecked = setupVM.teachertype[teachertype][subModuleId]

				if (isChecked) {
					let object = isTeacherTypeChild(teachertype)

					if (object) {
						enableParentModuleForTeacher(subModuleId, teachertype, object)
					} else {
						enableChildModulesForTeacher(subModuleId, teachertype)
					}
				} else {
					disableChildModulesForTeacher(subModuleId, teachertype)
				}
			}

			// selección de realiza plan de trabajo o no
			if (subModuleId === 1) { // todo change this to match don't do workplan
				if (setupVM.teachertype[teachertype]) {
					for (var association in setupVM.teachertype[teachertype]) {
						if (association && association == 1) {
							if (!setupVM.teachertype[teachertype][association]) {
								toggleModulesForTeacher(teachertype, false)
							} else {
								toggleModulesForTeacher(teachertype, teachertype)
								enableParentModuleForTeacher(subModuleId, teachertype, null)
							}
						}
					}
				}
			} else {
				if (setupVM.teachertype[teachertype][subModuleId])
					enableModulesForTeacher(subModuleId, teachertype) // colocamos realiza plan de trabajo seleccionado
				else
					checkDisableModuleForTeacher(subModuleId, teachertype)
			}

			// validaciones del formulario
			if (isEmptyTeachertype() || !isActivitySelected())
				setupVM.isButtonDisabled = true
			else
				setupVM.isButtonDisabled = false

			//setupVM.categorySubmodule
			var count = {}, count1 = {}

			for (var i in setupVM.categorySubmodule) {
				if (setupVM.categorySubmodule[i] != false) {
					var parent_id = i

					for (var k1 in setupVM.teachertype[parent_id]) {
						if (setupVM.teachertype[parent_id][k1] != false) {
							if (typeof count1[parent_id] === 'undefined') {
								count1[parent_id] = {}
							}

							count1[parent_id] = setupVM.teachertype[parent_id]
						}
					}

					if (typeof count1[parent_id] !== 'undefined') {
						count1[parent_id] = {}
						for (var j in setupVM.categorySubmodule[i]) {
							var id_code = setupVM.categorySubmodule[i][j].id_code

							for (var k in setupVM.teachertype[id_code]) {
								if (setupVM.teachertype[id_code][k] != false) {
									if (typeof count1[parent_id][id_code] === 'undefined') {
										count1[parent_id][j] = {}
									}

									count1[parent_id][id_code] = setupVM.categorySubmodule[i][j]
								}
							}
						}
					}
				}
			}

			for (var t in count1) {
				var size = Object.keys(count1[t]).length

				if (size <= 0) {
					setupVM.isButtonDisabled = true
				}
			}
		}

		function enableParentModuleForTeacher (subModuleId, teachertype, object) {
			if (object) {
				enable(object, subModuleId)
			} else {
				if (setupVM.teachertype[teachertype][subModuleId]) {
					let object = isTeacherTypeChild(teachertype)

					if (object) {
						enable(object, subModuleId)
					}
				}
			}

			function enable (object, subModuleId) {
				let parent = object.parent

				setupVM.teachertype[parent.id_code][subModuleId] = parent.id_code

				if (subModuleId == 1) {
					for (var t in setupVM.teachertype[parent.id_code]) {
						setupVM.teachertype[parent.id_code][t] = parent.id_code
					}
				}

				enableModulesForTeacher(subModuleId, parent.id_code)
			}
		}

		function isTeacherTypeChild (teachertype) {
			let result = false

			setupVM.teacherCategories.forEach((object) => {
				if (object.childs && object.childs.length > 0) {
					let isChild = object.childs.find((child) => child.id_code === teachertype)

					if (isChild) {
						result = {
							parent: object,
							child : isChild,
						}

						return
					}
				}
			})

			return result
		}

		function disableChildModulesForTeacher (subModuleId, teachertype) {
			let row = setupVM.teacherCategories.find((object) => object.id_code === teachertype)

			if (row && row.childs && row.childs.length > 0) {
				let isParentCheckActive = setupVM.teachertype[teachertype][subModuleId]

				row.childs.forEach((child) => {
					if (!isParentCheckActive) {
						if (subModuleId === 1) {
							toggleModulesForTeacher(child.id_code, false)
						} else {
							setupVM.teachertype[child.id_code][subModuleId] = false
						}
					}

					checkDisableModuleForTeacher(subModuleId, child.id_code)
				})
			}
		}

		function enableChildModulesForTeacher (subModuleId, teachertype) {
			let row = setupVM.teacherCategories.find((object) => object.id_code === teachertype)

			if (row && row.childs && row.childs.length > 0) {
				row.childs.forEach((child) => {
					setupVM.teachertype[child.id_code][subModuleId] = child.id_code
					setupVM.teachertype[child.id_code]['1'] = child.id_code

					if (subModuleId == 1)
						toggleModulesForTeacher(child.id_code, child.id_code)
				})
			}
		}

		function isEmptyTeachertype () {
			let arr = processActivitiesInformation()

			return arr.length === 0
		}

		function toggleModulesForTeacher (teachertype, value) {
			for (var association in setupVM.teachertype[teachertype]) {
				setupVM.teachertype[teachertype][association] = value
			}
		}

		function enableModulesForTeacher (subModuleId, teachertype) {
			for (var association in setupVM.teachertype[teachertype]) {
				setupVM.teachertype[teachertype]['1'] = teachertype // todo change this to match a variable
			}
		}

		function setAllProfessorChecked (check) {
			const result = []

			setupVM.teacherCategories.forEach(function (teacherType) {
				if (teacherType) {
					result[teacherType.id_code] = {}
					setupVM.submodules.forEach(function (module) {
						if (check)
							result[teacherType.id_code][module.id_code] = teacherType.id_code
						else
							result[teacherType.id_code][module.id_code] = false
					})

					if (teacherType.childs.length > 0) {
						teacherType.childs.forEach(function (child) {
							if (child) {
								result[child.id_code] = {}
								setupVM.submodules.forEach(function (module) {
									if (check)
										result[child.id_code][module.id_code] = child.id_code
									else
										result[child.id_code][module.id_code] = false
								})
							}
						})
					}
				}
			})

			return result
		}

		function setWorkplanAlreadyChecked (teacherSubmoduleRelation) {
			teacherSubmoduleRelation.forEach(function (relation) {
				setupVM.teachertype[relation.id_teacher_type][relation.id_submodule.toString()] = relation.id_teacher_type
			})
		}

		function toggleSubcategories (category) {
			if (category.showChilds) {
				category.showChilds = false
			} else {
				category.showChilds = true
			}
		}
		// MODAL DEFINITIONS
		function showModalActivitesSetedUp () {
			let planName = setupVM.workplan.plan_name
			let workPlanId = $stateParams.workPlanId
			let workPlanIdCloned = $stateParams.workPlanIdCloned

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.planName = planName
					$scope.workPlanId = workPlanId
					$scope.workPlanIdCloned = workPlanIdCloned
					$scope.close = function () {
						$mdDialog.hide()
					}
				} ],
				template           : require('./modalActivitesSetedUp.html'),
				clickOutsideToClose: false,
			})
		}

		function showModalActivitesSetedUpError (message) {
			let errorMessage = message

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.errorMessage = errorMessage
					$scope.close = function () {
						$mdDialog.hide()
					}
				} ],
				template           : require('./modalActivitesSetedUpError.html'),
				clickOutsideToClose: false,
			})
		}

		function isActivitySelected() {
			var BreakException = {}

			try {
				setupVM.teachertype.forEach(function (teacherType) {
					if (teacherType) {
						var count = Object.values(teacherType).reduce(function(n, val) {
							return n + (val === false)
						}, 0)

						if (count == 5) {
							throw BreakException
						}
					}
				})

				return true
			} catch (e) {
				if (e == BreakException) {
					return false
				}
			}
		}

		function checkDisableModuleForTeacher(subModuleId, teachertype) {
			var count = Object.values(setupVM.teachertype[teachertype]).reduce(function(n, val) {
				return n + (val === false)
			}, 0)
			let parent = isTeacherTypeChild(teachertype)

			if (parent) {
				if (count == 5) {
					setupVM.teachertype[teachertype]['1'] = false
					checkDisableParentModuleForTeacher('1', parent)
				}

				checkDisableParentModuleForTeacher(subModuleId, parent)
			} else {
				checkDisableDoWorkPlan(subModuleId, teachertype)
			}
		}

		function checkDisableParentModuleForTeacher(subModuleId, object) {
			let teachers = getTeacherTypeChilds(object.parent.id_code)
			let count = 0

			teachers.childs.forEach(function (child) {
				if (setupVM.teachertype[child.id_code] &&
          setupVM.teachertype[child.id_code][subModuleId]) {
					count = count + 1
				}
			})

			if (count == 0)
				disable(subModuleId, object)
		}

		function checkDisableDoWorkPlan(subModuleId, teachertype) {
			let count = 0

			for (var association in setupVM.teachertype[teachertype]) {
				if (setupVM.teachertype[teachertype][association])
					count = count + 1
			}

			if (count == 1)
				setupVM.teachertype[teachertype]['1'] = false
		}

		function disable (subModuleId, object) {
			let parent = object.parent

			setupVM.teachertype[parent.id_code][subModuleId] = false
		}

		function getTeacherTypeChilds (teachertype) {
			let result = []

			setupVM.teacherCategories.forEach((object) => {
				if (object.id_code == teachertype && object.childs.length > 0) {
					result = object

					return
				}
			})

			return result
		}

		function getAllTeachersActivities (header) {
			return WorkPlanParametrizationSrv.getAllActivities.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					setupVM.submodules = dataReturn.submodules
					setupVM.teacherCategories = dataReturn.categories
					setupVM.workplan = dataReturn.workPlan
					setupVM.workplan.id_code = header.workplanId
					for (var i in setupVM.teacherCategories) {
						if (typeof setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] === 'undefined') {
							setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = {}

							if (setupVM.teacherCategories[i].childs.length > 0) {
								setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = setupVM.teacherCategories[i].childs
							} else {
								setupVM.categorySubmodule[setupVM.teacherCategories[i].id_code] = false
							}
						}
					}
					getRelationTeacherSubmodules(dataReturn.relationTeacherSubmodule)
				}
			})
		}

		function getRelationTeacherSubmodules (header) {
			if (header) {
				if (header.length > 0) {
					setupVM.teachertype = setAllProfessorChecked(false)
					setWorkplanAlreadyChecked(header)
				} else {
					setupVM.teachertype = setAllProfessorChecked(true)
				}

				setupVM.isButtonDisabled = !isActivitySelected() && !isEmptyTeachertype()
			} else {
				console.log('error receiving getRelationTeacherSubmodules')
			}
		}

		// INITIALIZATION
		activate()
	}

}

SetupTeacherActivitiesCtrl.$inject = [ '$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$timeout' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/activities/setupTeacherActivitiesCtrl.js